module.exports = __webpack_public_path__ + "images/custom-black-46b682f8.svg";